var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
var FakeOverlay = styled.dialog(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: inherit;\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n"], ["\n  background: inherit;\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 1;\n"])));
export default FakeOverlay;
var templateObject_1;
